import React, { useState } from 'react';
import ContactsDirectory from './ContactsDirectory';
import MessagingHub from './MessagingHub';
import BroadcastTool from './BroadcastTool';
import RoyalAudioTool from './RoyalAudioTool';
import CollaborationBoard from './CollaborationBoard';
import ResolutionGenerator from './ResolutionGenerator';
import BackupManagement from './BackupManagement';
import { EmailTemplateManager } from './EmailTemplateManager';

export const CommunicationPortal: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    'contacts' | 'messaging' | 'broadcast' | 'audio' | 'collaboration' | 'resolutions' | 'backups' | 'templates'
  >('contacts');

  return (
    <div className="min-h-screen bg-slate-950 text-white p-4 md:p-8 lg:p-12 space-y-6">
      {/* Portal Top Header Banner */}
      <div className="bg-gradient-to-r from-emerald-950 via-slate-900 to-emerald-950 border border-amber-500/40 p-6 rounded-3xl shadow-2xl flex flex-col xl:flex-row justify-between items-start xl:items-center gap-6">
        <div className="flex items-center gap-4">
          <img
            src="https://res.cloudinary.com/uuovmrek/image/upload/uzairuelogo01"
            alt="Uzairue Kingdom Crest"
            className="w-14 h-14 rounded-full border-2 border-amber-400 shadow-md object-contain"
            referrerPolicy="no-referrer"
          />
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-xl md:text-2xl font-black font-serif text-amber-300 uppercase tracking-wide">
                Uzairue Global Communication & Collaboration Portal
              </h1>
              <span className="bg-amber-400 text-slate-950 text-[10px] px-2.5 py-0.5 rounded-full font-extrabold uppercase font-mono">
                ERUE 2026
              </span>
            </div>
            <p className="text-xs text-slate-300 mt-1 max-w-2xl">
              Official messaging suite, global contacts register, WhatsApp broadcast dispatcher, audio proclamations, collaboration board & database backup engine
            </p>
          </div>
        </div>

        {/* Tab Navigation Controls */}
        <div className="flex bg-slate-950/90 p-1.5 rounded-2xl border border-slate-800 flex-wrap gap-1 w-full xl:w-auto">
          <button
            onClick={() => setActiveTab('contacts')}
            className={`px-3.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer flex items-center gap-1.5 ${
              activeTab === 'contacts' ? 'bg-amber-500 text-slate-950 shadow-lg' : 'text-slate-300 hover:text-white'
            }`}
          >
            <span>📇</span> Contacts
          </button>

          <button
            onClick={() => setActiveTab('messaging')}
            className={`px-3.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer flex items-center gap-1.5 ${
              activeTab === 'messaging' ? 'bg-amber-500 text-slate-950 shadow-lg' : 'text-slate-300 hover:text-white'
            }`}
          >
            <span>💬</span> Channels
          </button>

          <button
            onClick={() => setActiveTab('broadcast')}
            className={`px-3.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer flex items-center gap-1.5 ${
              activeTab === 'broadcast' ? 'bg-amber-500 text-slate-950 shadow-lg' : 'text-slate-300 hover:text-white'
            }`}
          >
            <span>📢</span> Broadcasts
          </button>

          <button
            onClick={() => setActiveTab('audio')}
            className={`px-3.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer flex items-center gap-1.5 ${
              activeTab === 'audio' ? 'bg-amber-500 text-slate-950 shadow-lg' : 'text-slate-300 hover:text-white'
            }`}
          >
            <span>🎺</span> Royal Audio
          </button>

          <button
            onClick={() => setActiveTab('collaboration')}
            className={`px-3.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer flex items-center gap-1.5 ${
              activeTab === 'collaboration' ? 'bg-amber-500 text-slate-950 shadow-lg' : 'text-slate-300 hover:text-white'
            }`}
          >
            <span>📋</span> Tasks
          </button>

          <button
            onClick={() => setActiveTab('resolutions')}
            className={`px-3.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer flex items-center gap-1.5 ${
              activeTab === 'resolutions' ? 'bg-amber-500 text-slate-950 shadow-lg' : 'text-slate-300 hover:text-white'
            }`}
          >
            <span>📜</span> Resolutions
          </button>

          <button
            onClick={() => setActiveTab('backups')}
            className={`px-3.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer flex items-center gap-1.5 ${
              activeTab === 'backups' ? 'bg-emerald-600 text-white shadow-lg' : 'text-slate-300 hover:text-white'
            }`}
          >
            <span>💾</span> DB & Backups
          </button>

          <button
            onClick={() => setActiveTab('templates')}
            className={`px-3.5 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer flex items-center gap-1.5 ${
              activeTab === 'templates' ? 'bg-amber-500 text-slate-950 shadow-lg' : 'text-slate-300 hover:text-white'
            }`}
          >
            <span>📧</span> Email Templates
          </button>
        </div>
      </div>

      {/* Main Tab Content Render */}
      <div className="transition-all duration-300">
        {activeTab === 'contacts' && <ContactsDirectory />}
        {activeTab === 'messaging' && <MessagingHub />}
        {activeTab === 'broadcast' && <BroadcastTool />}
        {activeTab === 'audio' && <RoyalAudioTool />}
        {activeTab === 'collaboration' && <CollaborationBoard />}
        {activeTab === 'resolutions' && <ResolutionGenerator />}
        {activeTab === 'backups' && <BackupManagement />}
        {activeTab === 'templates' && <EmailTemplateManager />}
      </div>
    </div>
  );
};

export default CommunicationPortal;
